import { getHref } from './meta';

var handlePost = function handlePost() {
  var windowOptions = 'scrollbars=yes,resizable=yes,toolbar=no,location=yes';
  var width = 550;
  var height = 420;
  var winHeight = screen.height;
  var winWidth = screen.width;
  var left = Math.round(winWidth / 2 - width / 2);
  var top = winHeight > height ? Math.round(winHeight / 2 - height / 2) : 0;
  var target = "https://www.facebook.com/sharer/sharer.php?u=".concat(getHref());
  window.open(target, 'intent', "".concat(windowOptions, ",width=").concat(width, ",height=").concat(height, ",left=").concat(left, ",top=").concat(top));
};

export default handlePost;